import * as Actions from '../../actions';

const initialState = { data: null };

const accessListReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ACCESS_LIST:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default accessListReducer;
